// extracted by mini-css-extract-plugin
export default {"modelName":"tb_VntJbvf"};